import React, { useEffect, useState } from "react";
import { WifiOff, CloudUpload, Loader2, Trash2, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { subscribeOffline, queueRemove } from "@/lib/offline";
import { syncOfflineQueue } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");

const QueueList = ({ pending }) => (
  <ul className="divide-y divide-slate-100 max-h-80 overflow-y-auto" data-testid="offline-queue-list">
    {pending.length === 0 && <li className="py-3 text-sm text-slate-500 italic">Nada pendente.</li>}
    {pending.map((j) => (
      <li key={j.id} className="py-2 flex items-center gap-2 text-sm" data-testid={`offline-job-${j.id}`}>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-slate-800 truncate">{j.label}</p>
          <p className="text-[11px] text-slate-500">{fmt(j.created_at)}</p>
          {j.error && <p className="text-[11px] text-rose-600 flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> {j.error}</p>}
        </div>
        <button type="button" onClick={() => { if (window.confirm("Cancelar este lançamento pendente?")) queueRemove(j.id); }}
          className="p-1.5 text-slate-400 hover:text-rose-600" data-testid={`offline-job-cancel-${j.id}`}>
          <Trash2 className="w-4 h-4" />
        </button>
      </li>
    ))}
  </ul>
);

export default function OfflineBar() {
  const [s, setS] = useState({ offline: false, pending: [], syncing: false });
  const [open, setOpen] = useState(false);
  useEffect(() => subscribeOffline(setS), []);
  const n = s.pending.length;
  if (!s.offline && n === 0) return null;
  return (
    <>
      <div className={`mb-3 rounded-xl px-3 py-2 flex items-center gap-2 text-[12px] ${s.offline ? "bg-slate-900 text-white" : "bg-amber-50 border border-amber-200 text-amber-900"}`} data-testid="offline-bar">
        {s.offline ? <WifiOff className="w-4 h-4 shrink-0" /> : s.syncing ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <CloudUpload className="w-4 h-4 shrink-0" />}
        <span className="flex-1 min-w-0">
          {s.offline ? <><b>Offline</b>{s.cachedAt ? ` — dados de ${fmt(s.cachedAt)}` : ""}</> : s.syncing ? "Enviando lançamentos…" : "Lançamentos aguardando envio"}
        </span>
        {n > 0 && (
          <button type="button" onClick={() => setOpen(true)} className="font-black underline shrink-0" data-testid="offline-pending-btn">{n} pendente(s)</button>
        )}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="offline-queue-dialog">
          <DialogHeader><DialogTitle>Lançamentos pendentes</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Feitos sem internet. São enviados sozinhos quando a conexão voltar.</p>
          <QueueList pending={s.pending} />
          <Button onClick={() => syncOfflineQueue()} disabled={s.offline || s.syncing} className="w-full" data-testid="offline-sync-now">
            {s.syncing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CloudUpload className="w-4 h-4 mr-2" />} Enviar agora
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
